// extracted by mini-css-extract-plugin
export default {"container":"BasicParameters_container__jn7uB"};